import { BaseComparerBuilder } from './BaseComparerBuilder';
import { IComparer } from './IComparer';

export class StringComparerBuilder<T> extends BaseComparerBuilder<T, string> {
    buildComparer(selector: (model: T) => string, ascending: boolean): IComparer<T> {
        return {
            compare: (x: T, y: T): number => {
                const xValue: string = selector(x) || '';
                const yValue: string = selector(y) || '';

                if (!xValue && !yValue) {
                    return 0;
                }

                if (!xValue || xValue < yValue) {
                    return -1 * this.getOrderMultiplier(ascending);
                }

                if (!yValue || xValue > yValue) {
                    return 1 * this.getOrderMultiplier(ascending);
                }

                return 0;
            },
        };
    }
}
